/**
 * Helper function to determine if an event should be handle by any of our
 * global event listeners.
 */
export function shouldHandleGlobalEvent(event: Event): boolean {
  return !event.defaultPrevented && event.target === document.body;
}
